/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';

const DefaultButtonAction = ({
  style = {},
  onReject,
  onApprove,
  approveText = 'Confirm',
}) => {
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: isWeb ? 'center' : 'space-between',
        ...style,
      }}>
      <View style={{ width: isWeb ? 150 : '48%', marginHorizontal: '1%' }}>
        <Button
          type="default"
          rounded={true}
          buttonStyle={{ width: '100%' }}
          title={
            <SociollaText
              type="bold"
              style={{ fontSize: 14, letterSpacing: 0.5 }}>
              Reject
            </SociollaText>
          }
          onPress={() => onReject()}
        />
      </View>
      <View style={{ width: isWeb ? 150 : '48%', marginHorizontal: '1%' }}>
        <Button
          rounded={true}
          buttonStyle={{ width: '100%' }}
          title={
            <SociollaText
              type="bold"
              style={{ fontSize: 14, letterSpacing: 0.5, color: Colors.white }}>
              {approveText}
            </SociollaText>
          }
          onPress={() => onApprove()}
        />
      </View>
    </View>
  );
};

export default DefaultButtonAction;
